import { makeStyles } from "@material-ui/core/styles";
import {
  DATA_VIEW_MIN_TABLE_HEIGHT_PX,
  DATA_VIEW_SHOT_HEADER_HEIGHT_PX,
} from "./sequencerDataViewLayout";

const useDataViewStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    minHeight: 0,
    height: "100%",
    width: "100%",
    display: "flex",
    gap: "8px",
    overflow: "hidden",
    backgroundColor: "#252A38 !important",
  },
  leftCol: {
    flex: "0 0 calc(70% - 8px)",
    minWidth: 0,
    minHeight: 0,
    maxHeight: "100%",
    alignSelf: "stretch",
    overflowX: "hidden",
    overflowY: "auto",
  },
  leftPanel: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100%",
    boxSizing: "border-box",
    borderRadius: "10px",
  },
  playerSection: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    flexShrink: 0,
    backgroundColor: "#252A38",
    width: "100%",
  },
  playerSectionHeader: {
    padding: "8px 10px",
    borderTop: "2px solid #1B1D28",
    height: `${DATA_VIEW_SHOT_HEADER_HEIGHT_PX}px`,
    boxSizing: "border-box",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
  },
  resizableDivider: {
    height: "8px",
    cursor: "row-resize",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.main,
    flexShrink: 0,
    position: "relative",
    zIndex: 2,
    "&:hover": {
      backgroundColor: "#353A47",
    },
  },
  resizableDividerHandle: {
    width: "32px",
    height: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#6C65D9",
    borderRadius: "4px",
  },
  tableSection: {
    flex: "1 0 auto",
    minHeight: `${DATA_VIEW_MIN_TABLE_HEIGHT_PX}px`,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    width: "100%",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "0 0 10px 10px",
    borderTop: "none",
  },
  rightCol: {
    flex: "0 0 calc(30% - 8px)",
    minWidth: 0,
    minHeight: 0,
    maxHeight: "100%",
    alignSelf: "stretch",
    overflow: "hidden",
    backgroundColor: "#252A38 !important",
    borderRight: "8px solid #252A38",
  },
  rightPanel: {
    height: "100%",
    width: "100%",
    overflow: "hidden",
    boxSizing: "border-box",
    backgroundColor: "#252A38 !important",
  },
  sectionLabel: {
    color: theme.palette.text.tertiary,
    fontSize: "14px",
  },
  flexGap4: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  flexGap8: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  flexRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  clickableText: {
    color: "#606479",
    fontSize: "14px",
    cursor: "pointer",
    "&:hover": {
      color: "white",
    },
  },
}));

export default useDataViewStyles;
